__turbopack_context__.v({
  "className": "poppins_ff75d6e4-module__jqzVAW__className",
  "variable": "poppins_ff75d6e4-module__jqzVAW__variable",
});
